import script from "./TaskStatusBars.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskStatusBars.vue?vue&type=script&setup=true&lang=js"

import "./TaskStatusBars.vue?vue&type=style&index=0&id=5639d409&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5639d409"]])

export default __exports__